import type { Dayjs } from 'dayjs'
import { useTranslation } from 'next-i18next'
import { useMemo } from 'react'

import { cn } from '~/lib/utils'

import { DAYS_TO_DISPLAY } from '.'

interface DayColProps {
	selectedDay: Dayjs
	day: Dayjs
	onClick: () => void
	disabled?: boolean
}

export const DayCol = ({
	day,
	selectedDay,
	onClick,
	disabled,
}: DayColProps) => {
	const { t } = useTranslation()

	const isToday = day.isSame(selectedDay)

	const weekDaysShort = useMemo(
		() => Object.values(t('common:weekDays.short', { returnObjects: true })),
		[t],
	)

	const formatWeekday = (day: Dayjs) => weekDaysShort[day.weekday()]

	return (
		<div style={{ minWidth: `${100 / DAYS_TO_DISPLAY}%` }}>
			<div className='flex flex-col items-center gap-y-2'>
				<p className='text-slate-500 text-sm'>{formatWeekday(day)}</p>

				<button
					type='button'
					className={cn('h-9 w-9 rounded-full text-xs', {
						'bg-primary text-white hover:bg-primary focus:bg-primary': isToday,
						'opacity-30': disabled,
					})}
					disabled={disabled}
					onClick={onClick}
				>
					{day.format('DD')}
				</button>
			</div>
		</div>
	)
}
